/**
 * Page Scroll Animations
 * @requires https://lenis.darkroom.engineering/
 */

export default (() => {
  /* eslint-disable no-undef  */
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual'
  }

  // Always start at the top
  window.addEventListener('load', () => {
    window.scrollTo(0, 0)
  })

  // Also ensure unload doesn't save scroll position
  window.addEventListener('beforeunload', () => {
    window.scrollTo(0, 0)
  })

  const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smooth: true,
    smoothTouch: false,
  })

  // Animation frame loop for Lenis
  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
  }

  requestAnimationFrame(raf)

  // Hero Masked Video Animation
  const hero = document.querySelector('.hero-container')
  const overlay = document.querySelector('.text-overlay')
  const navbar = document.querySelector('.navbar')
  const heroContent = document.querySelector('.hero-content')
  const scrollIndicator = document.querySelector('.scroll-down')

  let heroHeight = hero.offsetHeight
  let windowHeight = window.innerHeight

  // Recalculate on resize
  window.addEventListener('resize', () => {
    heroHeight = hero.offsetHeight
    windowHeight = window.innerHeight
  })

  function heroAnimation(scroll) {
    const maxScroll = heroHeight - windowHeight
    let progress = scroll / maxScroll
    progress = Math.min(Math.max(progress, 0), 1)

    if (progress <= 0.95) {
      const p = progress / 0.95
      const scale = 1 + (10 - 1) * p
      overlay.style.transform = `scale(${scale})`
      overlay.style.opacity = 1 - 1.5 * p
    }

    if (progress >= 0.015) {
      scrollIndicator.classList.add('off-view')
    } else {
      scrollIndicator.classList.remove('off-view')
    }

    if (progress >= 0.7) {
      navbar.classList.add('in-view')
      heroContent.classList.add('in-view')
    } else {
      navbar.classList.remove('in-view')
      heroContent.classList.remove('in-view')
    }
  }

  lenis.on('scroll', ({ scroll }) => {
    heroAnimation(scroll)
  })

  // Scroll-down button behavior
  if (scrollIndicator) {
    scrollIndicator.addEventListener('click', (e) => {
      e.preventDefault()

      const maxScroll = heroHeight - windowHeight
      const targetScroll = maxScroll * 0.85

      lenis.scrollTo(targetScroll, {
        duration: 1.5,
        easing: (t) => t * t,
      })
    })
  }

  // Smooth scroll to anchor links
  const navLinks = document.querySelectorAll('.anchor-link')
  navLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault()
      const targetId = link.getAttribute('href')
      const targetSection = document.querySelector(targetId)

      if (targetSection) {
        lenis.scrollTo(targetSection, {
          offset: -72,
          duration: 1.5,
        })
      }
    })
  })

  // Scrollspy - Update active nav link based on scroll position
  const sections = document.querySelectorAll('.anchor-section')

  lenis.on('scroll', ({ scroll }) => {
    let current = ''

    sections.forEach((section) => {
      const sectionTop = section.offsetTop

      if (scroll >= sectionTop - 500) {
        current = section.id
      }
    })

    navLinks.forEach((link) => {
      link.classList.remove('active')

      if (link.getAttribute('href') === `#${current}`) {
        link.classList.add('active')
      }
    })
  })

  // Scroll-to-top button logic
  const scrollTopButton = document.querySelector('#btn-scroll-top')

  if (scrollTopButton) {
    const progress = scrollTopButton.querySelector('svg circle')
    const length = progress.getTotalLength()

    progress.style.strokeDasharray = length
    progress.style.strokeDashoffset = length

    const showProgress = (scroll, limit) => {
      const scrollPercent = scroll / limit
      const draw = length * scrollPercent
      progress.style.strokeDashoffset = length - draw
    }

    lenis.on('scroll', ({ scroll }) => {
      const maxScroll =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight

      // Show button when scrolling down
      if (scroll > heroHeight - windowHeight + 100) {
        scrollTopButton.classList.add('show')
      } else {
        scrollTopButton.classList.remove('show')
      }

      // Update circular progress
      showProgress(scroll, maxScroll)
    })

    // Smooth scroll to top with Lenis
    scrollTopButton.addEventListener('click', (e) => {
      e.preventDefault()
      lenis.scrollTo(0, {
        duration: 1.5,
      })
    })
  }

  /* eslint-enable no-undef  */
})()
